import { usePath4 } from "common/src/atoms/CdnAtom.bs";
import { make as ItemTooltip } from "common/src/tft-static/ItemTooltip.bs";
import ItemImage from "common/src/tft-static/ItemImage";
import * as T from "common/src/bindings/Translation2";
import { make as UnitImageExtended } from "common/src/tft-static/UnitImageExtended.bs";
import { use as useSet } from "common/src/data/TftSet.bs";
import { itemInfo } from "common/src/data/Data.bs";
import UnitImage from "common/src/tft-static/UnitImage";
import { PlainIcon2 } from "common/src/tft-static/TraitImage";

export const encodeItem = (id: string) =>
  id.replace(/TFT(.*?)_(Item|Consumable|Assist)_(.+)/, "$1$3");

const twoStarEl = (
  <div className="absolute left-0 top-[-6px] w-full flex justify-center">
    <svg width="22">
      <path
        fill={"var(--white1)"}
        transform={`translate(0,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
      <path
        fill={"var(--white1)"}
        transform={`translate(10,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
    </svg>
  </div>
);

const threeStarEl = (
  <div className="absolute left-[-2px] top-[-6px] w-[36px] flex justify-center">
    <svg width="36">
      <path
        fill={"rgba(255, 205, 79, 0.93)"}
        transform={`translate(0,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
      <path
        fill={"rgba(255, 205, 79, 0.93)"}
        transform={`translate(10,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
      <path
        fill={"rgba(255, 205, 79, 0.93)"}
        transform={`translate(20,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
    </svg>
  </div>
);

const fourStarEl = (
  <div className="absolute left-[-2px] top-[-6px] w-[36px] flex justify-center">
    <svg width="36">
      <path
        fill={"var(--teal-11)"}
        transform={`translate(0,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
      <path
        fill={"var(--teal-11)"}
        transform={`translate(10,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
      <path
        fill={"var(--teal-11)"}
        transform={`translate(20,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
      <path
        fill={"var(--teal-11)"}
        transform={`translate(30,0)scale(0.5)`}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      />
    </svg>
  </div>
);

const labelInner = (
  set: number,
  typ: string,
  count: any,
  rest?: Array<any>,
) => {
  // TFT15_SetMechanic_Remover
  if (typ === "TFT_Item_GrantOrnnAnvil") {
    return T.common("TFT_ArmoryKeyOrnn");
  } else if (typ === "TFT_Consumable_RecommendedArmoryRadiant") {
    return T.common("Radiant Armory");
  } else if (typ === "TFT14_Hack_Item_UnstableComponent") {
    return T.common("Unstable Component");
  } else if (typ === "TFT_Item_MadredsBloodrazorRadiant") {
    return T.items("5GiantSlayerRadiant");
  } else if (itemInfo("5" + encodeItem(typ), set)) {
    return T.items("5" + encodeItem(typ));
  } else if (typ.match(/TFT(.*?)_(Item|Consumable|Assist|Crime)_(.+)/)) {
    return T.items(encodeItem(typ));
  } else {
    switch (typ) {
      case "SetMechanicExtraTechniques":
        return T.items("TFT15_SetMechanic_Consumable");
      case "AUGMENT_SILVER":
        return T.common("Silver") + " " + T.common("Augment");
        // case "AUGMENT_GOLD":
        return T.common("Gold") + " " + T.common("Augment");
      case "AUGMENT_PRISMATIC":
        return T.common("Prismatic") + " " + T.common("Augment");
      case "CostUnit":
        return T.common("# Cost Unit").replace("#", rest![0]);
      case "StarUnit":
        return `${rest![0]}★ ` + T.common("# Cost Unit").replace("#", rest![1]);
      case "REMOVER":
        return T.items("ItemRemover");
      case "TFT15_SetMechanic_Remover":
        return T.items("TFT15_SetMechanic_Remover");
      case "ThievesGloves":
      case "THIEFSGLOVES":
        return T.items("ThiefsGloves");
      case "THIEFSGLOVES_RADIANT":
        return T.items("5ThiefsGlovesRadiant");
      case "TACTICIANS_CROWN":
      case "TACTICIANSCROWN":
      case "TACTICIANSITEMS":
        return T.items("ForceOfNature");
      case "CHALICE":
        return T.items("Chalice");
      case "LOCKET":
        return T.items("LocketOfTheIronSolari");
      case "ORNNRANDUINS":
        return T.items("4OrnnRanduinsSanctum");
      case "TRAININGDUMMY":
        return "Training Dummy";
      case "LOADEDDICE":
        return T.items("ShopReroller");
      case "SPATorPAN":
        return T.items("Spatula") + " / " + T.items("FryingPan");
      case "Spatula":
      case "SPAT_CannotBeShadow":
        return T.items("Spatula");
      case "FryingPan":
        return T.items("FryingPan");
      case "Duplicator":
      case "DUPLICATOR":
      case "CHAMPION_DUPLICATOR":
      case "Neeko":
      case "NEEKOSHELP":
        return T.items("ChampionDuplicator");
      case "LesserDuplicator":
      case "LESSERDUPLICATOR":
        return T.items("ChampionDuplicator_III");
      case "TFT_ArmoryKeyOrnn":
      case "TFT_ArmoryKeySupport":
      case "TFT_ArmoryKeyCompleted":
      case "TFT5_EmblemArmoryKey":
      case "TFT_ArmoryKeyComponent":
        return T.common(typ);
      case "RandomArtifact":
      case "ORNNARTIFACTS_NoGold":
      case "ORNNARTIFACTS_AD":
      case "ORNNARTIFACTS_ADBRUISER":
      case "ORNNARTIFACTS_TANK":
      case "ORNNARTIFACTS_SET6":
        return "Artifact Item";
      case "RADIANTITEM_NONSPECIFIC":
      case "RADIANTITEMS_SET5":
      case "RADIANTITEM":
      case "RADIANTITEMS_NOGLOVES":
      case "RADIANTITEM_NOGLOVES":
        return T.common("Radiant Item");
      case "TFT_RadiantConversion_PlayerBuff":
      case "TFT9_RadiantConversion_PlayerBuff":
        return T.common("Radiant Conversion");
      case "TFT_SentinelSwarm_PlayerBuff":
        return T.common("Sentinel Swarm");
      case "COMPLETEDITEMS":
        return count > 1 ? "Items" : "Item";
      case "COMPLETED_NOSPAT":
        return count > 1 ? "Items" : "Item";
      case "SUPPORTITEMS":
      case "SUPPORTNODISRUPT":
        return "Support " + (count > 1 ? "Items" : "Item");
      case "COMPONENT_NOSPAT": {
        if (T.common("Component") != "Component") {
          return T.common("Component");
        } else {
          return count > 1 ? "Compo- nents" : "Compo- nent";
        }
      }
      case "StageScaledGoldLarge":
        return T.common("Money") + " (5x stage)";
      case "Gold":
        return T.common("Money");
      case "GOLDXSMALL_SET7":
        return "3-5 " + T.common("Money");
      case "GOLDMEDIUM_SET7":
        return "7-10 " + T.common("Money");
      case "GOLDLARGE_SET7":
        return "20 " + T.common("Money");
      case "GOLDSMALL_SET7":
        return "5-7 " + T.common("Money");
      case "GOLDTEN_SET7":
        return "10 " + T.common("Money");
      case "OneCostUnit":
        return T.common("# Cost Unit").replace("#", "1");
      case "TwoCostUnit":
        return T.common("# Cost Unit").replace("#", "2");
      case "ThreeCostUnit":
      case "ThreecostUnit":
        return T.common("# Cost Unit").replace("#", "3");
      case "FourCostUnit":
        return T.common("# Cost Unit").replace("#", "4");
      case "FiveCostUnit":
        return T.common("# Cost Unit").replace("#", "5");
      case "OneCostUnitTwoStarUnit":
        return "2★ " + T.common("# Cost Unit").replace("#", "1");
      case "OneCostUnitThreeStarUnit":
        return "3★ " + T.common("# Cost Unit").replace("#", "1");
      case "TwoCostUnitTwoStarUnit":
        return "2★ " + T.common("# Cost Unit").replace("#", "2");
      case "ThreeCostUnitTwoStarUnit":
        return "2★ " + T.common("# Cost Unit").replace("#", "3");
      case "ThreeCostUnitThreeStarUnit":
        return "3★ " + T.common("# Cost Unit").replace("#", "3");
      case "FourCostUnitTwoStarUnit":
        return "2★ " + T.common("# Cost Unit").replace("#", "4");
      case "FiveCostUnitTwoStarUnit":
        return "2★ " + T.common("# Cost Unit").replace("#", "5");
      case "StageScaledTwoStar":
        return "2★ Unit (tier = stage - 1)";
      case "TFT_GrantThreeStarFiveCost_PlayerBuff":
      case "TFT9_Piltover_GrantThreeStarFiveCost_PlayerBuff":
        return "3★ " + T.common("# Cost Unit").replace("#", "5");
      case "REFORGER":
        return T.items("ItemReroller");
      case "REMOVERREFORGER":
        return "Remover / Reforger";
      case "BLANKSLOT_SET7":
        return "";
      case "ItemTier0":
        return "Tier 0 Item";
      case "ItemTier1":
        return "Tier 1 Item";
      case "ItemTier2":
        return "Tier 2 Item";
      case "ItemTier3":
        return "Tier 3 Item";
      case "ItemTier4":
        return T.items("TFT13_Crime_OmegaPrismatic_DimensionalHeirloom");
      case "EMBLEM_SET9":
      case "EMBLEM_SET14":
      case "EMBLEM_SET7_STAGE2":
        return T.common("Emblem");
      case "SpecificUnit":
        return T.units(count);
      case "SpecificUnitTwoStar":
        return "2★ " + T.units(count);
      case "SpecificUnitThreeStar":
        return "3★ " + T.units(count);
      case "SpecificUnitFourStar":
        return "4★ " + T.units(count);
      case "TrainingDummyWithItemTypes":
      case "TrainingDummyWithItems":
        return T.common("Itemized Dummy");
      case "RNGolem":
        return T.common("RNGolem");
      case "GolemWithItems":
        return T.common("Itemized Golem");
      case "PrismaticBeacon":
        return rest![0];
      case "BlobletExplosion":
        return "Bloblet Explosion";
      case "TFT_MaxLevelAndRerolls_PlayerBuff":
        return "Max level and rerolls";
      case "TFT_MostFieldedTraitsPack_Playerbuff":
        return "Most fielded traits pack";
      case "TFT_GrantFullRadiantItems":
        return "All radiant items";
      case "TFT11_Fortune_MysteryGift_PlayerBuff":
        return "Mystery Gift";
      case "TFT_CashoutTacticianHeal_PlayerBuff":
        return "Tactician Heal";
      case "TFT_PlusOneAllTraits_PlayerBuff":
        return "+1 All Traits";
      case "Exp":
        return T.common("Experience");
      case "Reroll":
        return T.common("Shop Refreshes");
      case "HP":
        return T.common("HP");
      case "GoldenEgg":
        return T.common("Egg");
      case "TFT15_CrystalRose_StarGuardianTowerDefense_PlayerBuff":
        return T.common("Star Guardian Tower Defense");
      case "TFT15_CrystalRoseCashout_TripleLeeSin":
        return T.common("Triple Lee Sin");
      case "TFT15_CrystalRose_MonsterTrainerCashout_PlayerBuff":
        return T.common("Monster Trainer Cashout");
      case "TFT15_CrystalRose_MMCashout_Playerbuff":
        return T.common("Mighty Mech Cashout");
      case "TFT15_CrystalRose_KayleCashoutPlayerBuff":
        return T.common("Kayle Cashout");
      default:
        return typ;
    }
  }
};

const label = (set: number, typ: string, count: number, rest?: Array<any>) => {
  let prefix = "";
  if (count > 1 || typ === "Gold") {
    if (typ.includes("CostUnit")) {
      prefix = `${count}x `;
    } else {
      prefix = `${count} `;
    }
  }

  return prefix + labelInner(set, typ, count, rest);
};

const element = (
  set: number,
  basePath: string,
  typ: string,
  count: any,
  rest: Array<any> = [],
) => {
  const size = 32;
  const w = String(size);
  const h = String(size);

  if (typ === "TFT_Item_GrantOrnnAnvil") {
    return (
      <img
        src={`${basePath}/reward/ornn_item_anvil.jpg?w=${w}`}
        width={w}
        height={h}
      />
    );
  } else if (typ === "TFT_Consumable_RecommendedArmoryRadiant") {
    return (
      <img
        src={`${basePath}/reward/random_radiant.jpg?w=${w}`}
        width={w}
        height={h}
      />
    );
  } else if (typ === "TFT9_Consumable_GoldenItemRemover") {
    return <ItemImage itemId="TFT9_Consumable_GoldenItemRemover" size={size} />;
  } else if (typ === "TFT_Item_MadredsBloodrazorRadiant") {
    return <ItemImage itemId={"5GiantSlayerRadiant"} size={size} />;
  } else if (itemInfo("5" + encodeItem(typ), set)) {
    return (
      <ItemTooltip itemId={"5" + encodeItem(typ)}>
        <ItemImage itemId={"5" + encodeItem(typ)} size={size} />
      </ItemTooltip>
    );
  } else if (typ.match(/TFT(.*?)_(Item|Consumable|Assist|Crime)_(.+)/)) {
    return (
      <ItemTooltip itemId={encodeItem(typ)}>
        <ItemImage itemId={encodeItem(typ)} size={size} />
      </ItemTooltip>
    );
  } else {
    switch (typ) {
      case "SetMechanicExtraTechniques":
        return (
          <ItemTooltip itemId={encodeItem("TFT15_SetMechanic_Consumable")}>
            <ItemImage
              itemId={encodeItem("TFT15_SetMechanic_Consumable")}
              size={size}
            />
          </ItemTooltip>
        );
      case "AUGMENT_SILVER": {
        return (
          <img
            src={`https://ap.tft.tools/img/augments/legend_augment1.png?w=${size}`}
            width={size}
            height={size}
          />
        );
      }
      case "AUGMENT_GOLD": {
        return (
          <img
            src={`https://ap.tft.tools/img/augments/legend_augment22.png?w=${size}`}
            width={size}
            height={size}
          />
        );
      }
      case "AUGMENT_PRISMATIC": {
        return (
          <img
            src={`https://ap.tft.tools/img/augments/legend_augment33.png?w=${size}`}
            width={size}
            height={size}
          />
        );
      }
      case "CostUnit": {
        return (
          <img
            src={`${basePath}/general/${rest[0]}cost.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "StarUnit": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/${rest[1]}cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {rest[0] == 2 ? twoStarEl : rest[0] == 3 ? threeStarEl : fourStarEl}
          </div>
        );
      }
      case "REMOVER": {
        return <ItemImage itemId="ItemRemover" size={size} />;
      }
      case "TFT15_SetMechanic_Remover": {
        return <ItemImage itemId="TFT15_SetMechanic_Remover" size={size} />;
      }
      case "ThievesGloves":
      case "THIEFSGLOVES": {
        return <ItemImage itemId="ThiefsGloves" size={size} />;
      }
      case "THIEFSGLOVES_RADIANT": {
        return <ItemImage itemId="5ThiefsGlovesRadiant" size={size} />;
      }
      case "TACTICIANS_CROWN":
      case "TACTICIANSITEMS":
      case "TACTICIANSCROWN": {
        return <ItemImage itemId="ForceOfNature" size={size} />;
      }
      case "CHALICE": {
        return <ItemImage itemId="Chalice" size={size} />;
      }
      case "LOCKET": {
        return <ItemImage itemId="LocketOfTheIronSolari" size={size} />;
      }
      case "ORNNRANDUINS": {
        return <ItemImage itemId="4OrnnRanduinsSanctum" size={size} />;
      }

      case "TRAININGDUMMY": {
        return (
          <img
            src={`${basePath}/face/TFT_TrainingDummy.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      // TFT_TrainingDummy
      case "LOADEDDICE": {
        return <ItemImage itemId="ShopReroller" size={size} />;
      }
      case "Spatula":
      case "SPATorPAN":
      case "SPAT_CannotBeShadow": {
        return <ItemImage itemId="Spatula" size={size} />;
      }
      case "FryingPan": {
        return <ItemImage itemId="FryingPan" size={size} />;
      }
      case "Duplicator":
      case "DUPLICATOR":
      case "CHAMPION_DUPLICATOR":
      case "NEEKOSHELP":
      case "Neeko": {
        return <ItemImage itemId="ChampionDuplicator" size={size} />;
      }
      case "LesserDuplicator":
      case "LESSERDUPLICATOR": {
        return <ItemImage itemId="ChampionDuplicator_III" size={size} />;
      }
      case "TFT_ArmoryKeyOrnn": {
        return (
          <img
            src={`${basePath}/reward/ornn_item_anvil.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "TFT_ArmoryKeySupport": {
        return (
          <img
            src={`${basePath}/reward/support_item_anvil.png?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "TFT_ArmoryKeyCompleted": {
        return (
          <img
            src={`${basePath}/reward/completed_item_anvil.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "TFT_ArmoryKeyComponent": {
        return (
          <img
            src={`${basePath}/reward/component_anvil.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "RandomArtifact":
      case "ORNNARTIFACTS_NoGold":
      case "ORNNARTIFACTS_AD":
      case "ORNNARTIFACTS_ADBRUISER":
      case "ORNNARTIFACTS_TANK":
      case "ORNNARTIFACTS_SET6": {
        return (
          <img
            src={`${basePath}/reward/random_ornn.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "RADIANTITEM_NONSPECIFIC":
      case "RADIANTITEMS_SET5":
      case "RADIANTITEM":
      case "RADIANTITEMS_NOGLOVES":
      case "RADIANTITEM_NOGLOVES":
      case "TFT_RadiantConversion_PlayerBuff":
      case "TFT9_RadiantConversion_PlayerBuff": {
        return (
          <img
            src={`${basePath}/reward/random_radiant.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "ItemTier0":
      case "ItemTier1":
      case "ItemTier2":
      case "ItemTier3":
      case "SUPPORTITEMS":
      case "SUPPORTNODISRUPT":
      case "COMPLETED_NOSPAT":
      case "COMPLETEDITEMS": {
        return (
          <img
            src={`${basePath}/reward/tmp_random_item.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "ItemTier4": {
        return (
          <ItemImage
            itemId={"TFT13_Crime_OmegaPrismatic_DimensionalHeirloom"}
            size={Number(w)}
          />
        );
      }

      case "COMPONENT_NOSPAT": {
        return (
          <img
            src={`${basePath}/reward/random_component.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "TFT5_EmblemArmoryKey": {
        return (
          <img
            src={`${basePath}/reward/tome_of_traits.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "StageScaledGoldLarge":
      case "GOLDXSMALL_SET7":
      case "GOLDMEDIUM_SET7":
      case "GOLDLARGE_SET7":
      case "GOLDSMALL_SET7":
      case "GOLDTEN_SET7":
      case "Gold": {
        return (
          <img
            src={`${basePath}/reward/gold.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "Boot": {
        return (
          <img
            src={`${basePath}/reward/boot.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "OneCostUnit": {
        return (
          <img
            src={`${basePath}/general/1cost.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "TwoCostUnit": {
        return (
          <img
            src={`${basePath}/general/2cost.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "ThreecostUnit":
      case "ThreeCostUnit": {
        return (
          <img
            src={`${basePath}/general/3cost.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "FourCostUnit": {
        return (
          <img
            src={`${basePath}/general/4cost.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "FiveCostUnit": {
        return (
          <img
            src={`${basePath}/general/5cost.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      }
      case "StageScaledTwoStar":

      case "OneCostUnitThreeStarUnit": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/1cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {twoStarEl}
          </div>
        );
      }
      case "OneCostUnitTwoStarUnit": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/1cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {twoStarEl}
          </div>
        );
      }
      case "TwoCostUnitTwoStarUnit": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/2cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {twoStarEl}
          </div>
        );
      }
      case "ThreeCostUnitTwoStarUnit": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/3cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {twoStarEl}
          </div>
        );
      }
      case "ThreeCostUnitThreeStarUnit": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/3cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {threeStarEl}
          </div>
        );
      }
      case "FourCostUnitTwoStarUnit": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/4cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {twoStarEl}
          </div>
        );
      }
      case "FiveCostUnitTwoStarUnit": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/5cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {twoStarEl}
          </div>
        );
      }
      case "TFT_GrantThreeStarFiveCost_PlayerBuff":
      case "TFT9_Piltover_GrantThreeStarFiveCost_PlayerBuff": {
        return (
          <div className="relative">
            <img
              src={`${basePath}/general/5cost.jpg?w=${w}`}
              width={w}
              height={h}
            />
            {threeStarEl}
          </div>
        );
      }
      case "REFORGER": {
        return <ItemImage itemId="ItemReroller" size={size} />;
      }
      case "REMOVERREFORGER": {
        return (
          <div className={`relative w-[28px] h-[28px]`}>
            <ItemImage
              className="absolute left-0 top-0"
              itemId="ItemReroller"
              size={size}
            />
            <ItemImage
              className="absolute left-0 top-0 triangle-clip"
              itemId="ItemRemover"
              size={size}
            />
          </div>
        );
      }
      case "BLANKSLOT_SET7":
        return null;
      case "EMBLEM_SET9":
      case "EMBLEM_SET14":
      case "EMBLEM_SET7_STAGE2":
        return (
          <img
            src={`${basePath}/reward/random_emblem.jpg?w=${w}`}
            width={w}
            height={h}
          />
        );
      case "SpecificUnit": {
        return <UnitImage unitId={count} size={Number(w)} showName={false} />;
      }
      case "SpecificUnitTwoStar": {
        return (
          <UnitImageExtended
            unitId={count}
            starLevel={2}
            items={[]}
            size={Number(w)}
            showName={false}
          />
        );
      }
      case "SpecificUnitThreeStar": {
        return (
          <UnitImageExtended
            unitId={count}
            starLevel={3}
            items={[]}
            size={Number(w)}
            showName={false}
          />
        );
      }
      case "SpecificUnitFourStar": {
        return (
          <UnitImageExtended
            unitId={count}
            starLevel={4}
            items={[]}
            size={Number(w)}
            showName={false}
          />
        );
      }
      case "TrainingDummyWithItemTypes": {
        const items = [count, ...rest].map((itemId) => {
          switch (itemId) {
            case "RADIANTWARMOGS":
              return "5WarmogsArmorRadiant";
            default:
              return "AegisOfTheLegion";
          }
        });

        return (
          <UnitImageExtended
            unitId={"TFT_TrainingDummy"}
            items={items}
            size={Number(w)}
            itemSize={items.length < 3 ? 15 : 11}
            showName={false}
          />
        );
      }
      case "TrainingDummyWithItems": {
        const items = Number.isInteger(count) ? rest : [count, ...rest];
        return (
          <UnitImageExtended
            unitId={"TFT_TrainingDummy"}
            items={items}
            size={Number(w)}
            itemSize={items.length < 3 ? 15 : 11}
            showName={false}
          />
        );
      }
      case "RNGolem":
        return (
          <UnitImageExtended
            unitId={"TFT_BlueGolem"}
            items={[]}
            size={Number(w)}
            showName={false}
          />
        );
      case "GolemWithItems": {
        const items = Number.isInteger(count) ? rest : [count, ...rest];
        return (
          <UnitImageExtended
            unitId={"TFT_BlueGolem"}
            items={items}
            size={Number(w)}
            itemSize={items.length < 3 ? 15 : 11}
            showName={false}
          />
        );
      }
      case "PrismaticBeacon": {
        return (
          <PlainIcon2 traitId={"TFT14_AnimaSquad"} rank={4} size={Number(w)} />
        );
      }
      case "BlobletExplosion": {
        <UnitImage unitId={"TFT14_Zac"} size={Number(w)} showName={false} />;
      }
      case "TFT_MaxLevelAndRerolls_PlayerBuff":
      case "TFT_MostFieldedTraitsPack_Playerbuff":
      case "TFT11_Fortune_MysteryGift_PlayerBuff":
      case "TFT_CashoutTacticianHeal_PlayerBuff":
      case "TFT_PlusOneAllTraits_PlayerBuff":
      case "TFT_SentinelSwarm_PlayerBuff":
      case "TFT_GrantFullRadiantItems": {
        return <ItemImage size={Number(w)} itemId="_" />;
      }
      case "Exp":
        return (
          <img
            src="https://ap.tft.tools/img/general/levelup.png"
            width={w}
            height={w}
          />
        );
      case "Reroll":
        return (
          <img
            src="https://ap.tft.tools/img/general/reroll.png"
            width={w}
            height={w}
          />
        );
      case "HP":
        return (
          <img
            src={`https://ap.tft.tools/img/augments/giantandmighty3.png?w=${w}`}
            width={w}
            height={w}
          />
        );
      case "GoldenEgg":
        return (
          <img
            src={`https://ap.tft.tools/img/reward/goldenegg.png?w=${w}`}
            width={w}
            height={w}
          />
        );
      case "TFT15_CrystalRose_StarGuardianTowerDefense_PlayerBuff":
        return <ItemImage size={Number(w)} itemId="_" />;
      case "TFT15_CrystalRoseCashout_TripleLeeSin":
        return <ItemImage size={Number(w)} itemId="_" />;
      case "TFT15_CrystalRose_MonsterTrainerCashout_PlayerBuff":
        return <ItemImage size={Number(w)} itemId="_" />;
      case "TFT15_CrystalRose_MMCashout_Playerbuff":
        return <ItemImage size={Number(w)} itemId="_" />;
      case "TFT15_CrystalRose_KayleCashoutPlayerBuff":
        return <ItemImage size={Number(w)} itemId="_" />;
      default: {
        return <div>{typ}</div>;
      }
    }
  }
};

const fixItem = (
  typ: string,
  count: number,
  rest: Array<any>,
): [string, number, Array<any>] => {
  switch (typ) {
    case "3LesserDuplicators":
      return ["LesserDuplicator", 3, rest];
    case "2randomComponents":
      return ["COMPONENT_NOSPAT", 2, rest];
    case "3randomComponents":
      return ["COMPONENT_NOSPAT", 3, rest];
    case "3TrainingDummies":
      return ["TRAININGDUMMY", 3, rest];
    case "20Gold":
      return ["Gold", 20, rest];
    case "30Gold":
      return ["Gold", 30, rest];
    case "Fishbones":
      return ["TFT_Item_Artifact_Fishbones", count, rest];
    case "PitFighterEmblem":
      return ["TFT13_Item_PitFighterEmblemItem", count, rest];
    case "AmbusherEmblem":
      return ["TFT13_Item_AmbusherEmblemItem", count, rest];
    case "WatcherEmblem":
      return ["TFT13_Item_WatcherEmblemItem", count, rest];
    default:
      return [typ, count, rest];
  }
};

const LootItem = ({
  typ: typBase,
  count: countBase,
  rest: restBase = [],
}: {
  typ: string;
  count: number;
  rest?: Array<any>;
}) => {
  const [typ, count, rest] = fixItem(typBase, countBase, restBase);
  const set = useSet();
  const basePath = usePath4();
  const text = label(set, typ, count, rest);
  const shouldBreak = Math.max(...text.split(" ").map((v) => v.length)) > 11;

  return (
    <div
      className={`min-h-[64px] flex flex-col items-center text-center gap-1 w-[76px] ${
        shouldBreak ? "break-all" : "break-normal"
      }`}
    >
      <div className="relative">
        {element(set, basePath, typ, count, rest)}
        {Number.isInteger(count) && count > 1 ? (
          <div className="absolute right-[1px] bottom-[-2px] text-shadow-strong text-sm">
            {"x" + count}
          </div>
        ) : null}
      </div>
      <div className="font-montserrat font-medium leading-tight text-[12px]">
        {text}
      </div>
    </div>
  );
};

export default LootItem;
